import React, { useMemo } from "react"
import { YMaps, Map, Placemark, ZoomControl } from "react-yandex-maps"

const YandexMap = () => {
  const mapElement = useMemo(
    () => (
      <YMaps>
        <Map
          width="100%"
          height="100%"
          defaultState={{
            center: [55.707777, 37.624565],
            zoom: 17
          }}
        >
          <Placemark
            geometry={[55.707806, 37.625524]}
            options={{
              iconLayout: "default#image"
              // iconImageHref: MapIcon,
              // iconImageSize: [43, 61],
              // iconImageOffset: [0, 0]
            }}
          />
          <ZoomControl
            options={{
              float: "left",
              size: "small",
              position: {
                right: "10px",
                bottom: "35px"
              }
            }}
          />
        </Map>
      </YMaps>
    ),
    []
  )
  return <>{mapElement}</>
}

export default YandexMap
